<template>
  <!-- ************* VETRINA DI UN FORNITORE **********  -->
  <!-- Mostra gli articoli che il fornitore Amilon vende -->
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Overlay pagina: in questo caso viene usato al momento della richiesta   -->
    <!-- di acquisto di un buono, la tabella dei buoni ha un overlay per suo conto-->
    <!-- al caricamento ed al cambio pagina.                                     -->
    <CustomOverlay :show="overlay_show" :text="overlay_message">
        <!-- Pulsante per tornare alla pagina dei fornitori -->
        <b-button pill size="sm" @click="$router.push( { name : 'conv-aml' } )">
          <b-icon icon="caret-left-fill"></b-icon>Torna indietro
        </b-button>

        <!-- LOGO E NOME DEL FORNITORE -->
        <!-- Carichiamo il logo solo quando le info per visualizzarlo -->
        <!-- sono disponibili.                                        -->
        <b-row class="mt-4" align-h="center">
          <b-col md="2" class='text-center'>
            <b-img v-if="forn_infos.MerchantImage150x150 !== null" :src="forn_infos.MerchantImage150x150" alt="logo"></b-img>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col class='text-justify' md="4">
            <h6 v-html="forn_infos.MerchantShortDescription"></h6>
          </b-col>
        </b-row>

        <!-- STRINGA DI RICERCA TRA GLI ARTICOLI -->
        <b-row class="mt-3 border-bottom" align-h="center">
          <b-col cols="md-4">
            <b-form-group id="group-item-search"
              label="Cerca tra gli articoli:"
              label-for="item-search">
                <b-form-input
                  id="item-search"
                  v-model="filtro_ricerca"
                  debounce="500"
                ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- CONTENUTO DELLA VETRINA -->
        <div class="mt-5">
          <!-- Overlay di caricamento della vetrina: per caricamento al cambio pagina -->
          <b-overlay :show="overlay_vetrina" spinner-variant="primary">
            <!-- VETRINA -->
            <!-- Se non ci sono prodotti disponibili visualizziamo un messaggio invece della pagina vuota -->
            <b-row v-if="parted_vetrina.length === 0 ">
              <b-col class="text-center">Nessun elemento trovato</b-col>
            </b-row>
            <!-- Altrimenti andiamo a renderizzare la lista -->
            <b-row v-else v-for="(row_elem, index) in parted_vetrina" :key="index" >
              <!-- Mettiamo 6 elementi per riga ( md-2 grandezza colonna 2)    -->
              <!-- sugli schermi piccoli andiamo in stacked, mentre la colonna -->
              <!-- è alta il 100% della riga ( classe h-100 ) -->
              <b-col :cols="item_column_size" class="item-container text-center h-100 mb-3 pb-2" v-for="( articolo, index ) in row_elem" :key="index">
                  <b-link class="item-link" @click="mostra_modale_acquisto(articolo)" :title="articolo.Name">
                    <!-- ICONA DEL BUONO -->
                    <b-img fluid class="img-preview" :src="articolo.ImageUrl"></b-img>
                    <!-- DESCRIZIONE DEL BUONO -->
                    <div class="mt-3 description-container">
                      <h6 class="description-text">{{articolo.Name}}</h6>
                    </div>
                  </b-link>
              </b-col>
            </b-row>
            <!-- PAGINATORE -->
            <b-pagination v-model="current_page"
                          v-if="show_paginatore"
                          :total-rows="total_rows"
                          :per-page="page_size"
                          @input="update_prodotti_da_paginatore"
                          align="center">
            </b-pagination>
          </b-overlay>
        </div>

        <!-- MODALE DI ACQUISTO DEL PRODOTTO -->
        <b-modal  size="lg"
                  centered
                  no-close-on-backdrop
                  no-close-on-esc
                  hide-header-close
                  :title='acq_modal_prod.Name'
                  v-model="show_acq_modal"
                  >
          <b-row>
            <b-col cols='md-6' class='text-center'>
              <span class="align-helper"></span>
              <b-img fluid :src="acq_modal_prod.ImageUrl"></b-img>
            </b-col>
            <b-col cols='md-6' class='mt-3 text-justify'>
              <p v-html="acq_modal_prod.MerchantLongDescription"></p>
            </b-col>
          </b-row>
          <!-- Ridefiniamo i bottoni, nel nostro caso serve il bottone annulla e quello di acquisto  -->
          <!-- viene inoltre controllato che l'utente abbia sufficiente credito per poter proseguire -->
          <!-- in tal caso viene visualizzato il messaggio di errore e non il pulsante acquista.     -->
          <template v-slot:modal-footer>
            <p v-if="is_credit_out" class='text-danger text-justify'>
              Non hai sufficiente credito per proseguire.
              Il massimo spendibile in quest'area utilizzando il credito welfare,
              ammonta a quanto attualmente disponibile per i buoni ( art. 51c3 ) e pari a
              {{ $store.state.user.user_credito.art51c3 }} €.
              Seleziona un altro buono dall'elenco il cui valore non superi tale cifra.
            </p>
            <b-button v-else size="sm" variant="primary" @click="esegui_acquisto()">
              Acquista
            </b-button>
            <b-button size="sm" variant="secondary" @click="chiudi_modale_acquisto()">
              Annulla
            </b-button>
          </template>
        </b-modal>
    </CustomOverlay>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'VetrinaFornAmilon',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Buoni - Voucher", link : 'conv-aml' },
                       { text : "Vetrina", link : '' } ],
      overlay_show: false,

      overlay_message: "Richiesta in corso, potrebbero essere necessari alcuni istanti, si prega di non chiudere questa finestra ed attendere...",

      // Array dei prodotti
      prodotti : [],

      // Informazioni sul fornitore
      forn_infos : {
        'MerchantImage150x150' : null,
        'MerchantName' : null,
        'MerchantShortDescription' : null
      },

      // Stringa di ricerca tra gli articoli.
      filtro_ricerca : null,

      // Overlay di caricamento della vetrina
      overlay_vetrina: false,

      // Numero di elementi per ogni riga
      item_by_row: 6,

      // Dimensione delle colonne con gli item, siccome
      // vogliamo avere 6 elementi per riga utilizziamo
      // la classe bootstrap md-2 ( 12/2 = 6 )
      item_column_size: "md-2",

      // -- Paginatore: --
      // Elementi per ogni pagina della vetrina, siccome
      // vogliamo mostrare 3 righe per pagina richiederemo
      // al backend una pagina di 18 elementi.
      page_size: 18,
      // Pagina corrente ( dato valorizzato dal paginatore di bootstrap )
      current_page: null,
      // Numero totale di elementi ( dato valorizzato dal backend )
      total_rows : null,

      // -- Acquisto: --
      // Prodotto scelto dall'utente da passare alla modale di acquisto.
      // Essendo richiesto un oggetto per renderizzare le info nella modale,
      // ne passo uno vuoto invece che null altrimenti avrei errore da
      // parte del componente.
      acq_modal_prod : {},
      // Boolean per aprire e chiudere la modale di acquisto collegata al
      // suo v-model
      show_acq_modal : false
    }
  },
  computed : {
    /**
     * Partiziona i prodotti del fornitore da array singola ad un'array
     * di array con 6 elementi per ogni sotto array ( ogni sotto array è
     * una riga )
     */
    parted_vetrina : function () {
      return generalLib.sub_array_partition( this.prodotti, this.item_by_row );
    },
    /**
     * Una variabile che indica se il paginatore deve comparire.
     * Dovrà essere visibile quando il numero di elementi totali supera
     * quello degli elementi in una pagina.
     */
    show_paginatore : function () {
      let res = false;
      if ( this.total_rows > this.page_size ) res = true;
      return res;
    },
    /**
     * Un flag che segnala, all'apertura della modale di acquisto,
     * che non è possibile continuare perchè il credito relativo
     * ai buoni non è sufficiente.
     */
    is_credit_out : function () {
      return this.$store.state.user.user_credito.art51c3 < this.acq_modal_prod.Price ? true : false;
    }
  },
  methods : {
    /**
     * Imposta il prodotto da acquistare nella modale di acquisto e la
     * apre.
     *
     * - articolo: oggetto che rappresenta il prodotto selezionato
     */
    mostra_modale_acquisto : function ( articolo ) {
      this.acq_modal_prod = articolo;
      this.show_acq_modal = true;
    },
    /**
     * Chiude la modale di acquisto resettando la variabile dell'oggetto
     * che rappresenta il prodotto da comperare.
     */
    chiudi_modale_acquisto : function () {
      this.show_acq_modal = false;
      this.acq_modal_prod = {};
    },
    /**
     * Prende le informazioni del fornitore traendole dal primo prodotto
     * nella lista dei prodotti.
     * Non può essere fatto con una computed perchè le informazioni devono
     * essere persistenti durante la vita della pagina, mentre l'array dei
     * prodotti può anche essere vuota se durante la ricerca per stringa
     * non si hanno risultati.
     */
    set_info_fornitore : function () {
      // Se le info sul fornitore sono state già settate ( uso il nome
      // per controllare ) o non ci sono prodotti allora torno.
      if ( this.forn_infos.MerchantName !== null || this.prodotti.length === 0 ) return;

      // Altrimenti le imposto, uso per l'oggetto le stesse chiavi
      // usate da Amilon
      this.forn_infos.MerchantImage150x150 = this.prodotti[0].MerchantImage150x150;
      this.forn_infos.MerchantName = this.prodotti[0].MerchantName;
      this.forn_infos.MerchantShortDescription = this.prodotti[0].MerchantShortDescription;
    },
    /**
     * Carica i prodotti del fornitore, permette di specificare la pagina da
     * caricare e l'eventuale filtro da applicare.
     * Si fa sempre riferimento al fornitore il cui id è specificato nell'apposita
     * prop "id_fornitore".
     * - page_num : numero di pagina da caricare.
     */
    carica_prodotti : function ( page_num = null, filter = null ){

      // Nella chiamata per Django specifichiamo sempre nella query string
      // la grandezza della pagina ( numero di elementi nella pagina restituita )
      // ed il fatto che vogliamo i prodotti ordinati per prezzo.
      let params = { page_size : this.page_size, price_sort : true };

      // Se specificato andiamo a settare in query string il numero di pagina richiesto.
      if ( page_num != null ) params['page'] = page_num;

      // Se passata usiamo la stringa di ricerca
      if ( this.filtro_ricerca !== null || this.filtro_ricerca !== '' ) params['filter'] = this.filtro_ricerca;

      let call_url = apiUrl.amilonapi.get_products_by_merchant.replace( '@merchant_code', this.id_fornitore )

      this.overlay_vetrina = true;

      axios.get( call_url, { params: params } )
      .then( ( response ) => {

        // Aggiorniamo le variabili interne
        this.prodotti = response.data.results;
        this.total_rows = response.data.count;

        // Se necessario, vengono settate le info sul fornitore
        this.set_info_fornitore();

        this.overlay_vetrina = false;
      })
      .catch( ( error ) => {
        this.overlay_vetrina = false;
        let message = "Si è verificato un errore nel caricamento della vetrina del fornitore, " +
                      "si prega di riprovare, se il problema persiste contattare l'assistenza";
        generalLib.backend_error_message_box( this, message );
        console.error( error.response.data );
      });
    },
    /**
     * Quando si modifica la pagina tramite il paginatore va ricaricare gli
     * item nell'array dei prodotti selezionando la pagina voluta.
     */
    update_prodotti_da_paginatore : function () {
      this.carica_prodotti( this.current_page );
    },
    /**
     * Esegue l'acquisto del prodotto impostato nella modale di acquisto
     */
    esegui_acquisto : function () {

      if (  this.acq_modal_prod === {} || this.acq_modal_prod === null ) {
        throw Error( 'Impossibile proseguire con l\'acquisto, articolo da acquistare non definito.' );
      }

      generalLib.acquisto_confirm_message_box (  this, this.acq_modal_prod.Price, 'art51c3' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla, chiudo la modale di acquisto
        // e torno.
        if ( !value ) {
          this.chiudi_modale_acquisto();
          return;
        }

        // Se invece l'utente decide di proseguire:
        // 1) Prendo il codice del prodotto da acquistare da inviare al
        //    backend perchè la successiva chiusura della modale di acquisto
        //    resetta tale informazione
        // 2) Chiudo la modale di acquisto
        // 3) Attivo l'overlay di attesa nel mentre che viene effettuata la richiesta
        let data_to_send = { product_code : this.acq_modal_prod.ProductCode }
        this.chiudi_modale_acquisto();
        this.overlay_show = true;

        axios.post( apiUrl.welfareapi.create_acq_amilon, data_to_send )
        .then( (response) => {

          this.overlay_show = false;

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home. Non possiamo usare quella della general lib perchè dobbiamo personalizzare
          // il messaggio.
          let mess = "La richiesta è stata inviata con successo con l'id " + response.data.id_acquisto +
                     ". Riceverai a breve un messaggio nella tua area notifiche welfarebit con il link " +
                     "per poter scaricare il buono acquistato. Il link è consultabile solo tramite " +
                     "tale area e non ti sarà inviato via mail. Se hai difficoltà a trovare il messaggio " +
                     "contatta il servizio assistenza."
          this.$bvModal.msgBoxOk( mess , {
            title: 'Richiesta inviata',
            buttonSize: 'sm',
            okVariant: 'success',
            centered: true
          })
          .then( ( value ) => {
            this.$router.push( { name : 'menu'} );
          })

        })
        .catch( (error) => {
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });

    }
  },
  /**
   * Carichiamo i prodotti del fornitore partendo dalla prima pagina
   * ( se ha più di "page_size" prodotti, altrimenti avremo una pagina
   * unica ).
   */
  created : function () {
    this.carica_prodotti();
  },
  watch : {
    /**
     * Al variare del filtro di ricerca effettuiamo il refresh
     * della vetrina.
     */
    filtro_ricerca : function ( val ){
      // se abbiamo cancellato la stringa di ricerca ricarichiamo
      // la vetrina ex-novo.
      if ( val == '' || val === null ) {
        this.carica_prodotti( null );
      } else {
        this.carica_prodotti( null );
      }
    }
  },
  props : {
    /**
     * Id del fornitore del quale visualizzare i dati, è necessario
     * fornirlo per poterlo visualizzare, solitamente è una stringa
     * alfanumerica del tipo: 875196f7-5e79-4e6d-8f8f-5e27f8fa2146
     */
    id_fornitore: {
      type: String,
      required: true
    }
  },
  components: {
    PageTagline,
    CustomOverlay
  }
}
</script>


<style scoped>

.forn-description {
  display: inline;
}

/* Immagine di anteprima degli articoli */
.img-preview {
  max-width: 300px;
  max-height: 150px;
}

/* La presenza del link non deve apportare modifiche
   al layout del contenuto */
.item-link {
 color: #000000;
}
.item-link:hover {
 text-decoration: none;
}

/* Quando passiamo sopra il testo della descrizione deve
   cambiare colore */
.item-link:hover .description-container {
  color:#a1a1a1;
}


/* Visualizziamo i puntini di sospensione nel testo della
  descrizione dopo la seconda riga. L'altezza dell'elemento
  che contiene la descrizione la fissiamo a 40px che sono
  l'altezza delle due righe.  */
.description-text {
  height: 40px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Un blocco span inline che serve come helper per allineare
   verticalmente il logo del buono, visto su:
   https://stackoverflow.com/questions/7273338/how-to-vertically-align-an-image-inside-a-div */
.align-helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

/* Negli schermi più piccoli del desktop deve comparire
   il bordo inferiore per separare tra loro gli articoli */
@media (max-width: 768px) {
  .item-container {
    border-bottom: 1px solid rgba(0,0,0,.125);
  }
}

</style>